import React, { useState, useEffect, useCallback } from "react";
import { MobileView, BrowserView } from "react-device-detect";
import { useParams, Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
// import { toast } from "react-toastify";
import Moment from "react-moment";
import axios from "axios";
import { logout } from "../state/action-creator/index";
import { bindActionCreators } from "redux";
import { actionCreators } from "../state/index";
import { Helmet } from "react-helmet";
import useTranslation from "../hooks/useTranslation";
import SingleElimination from "../components/SingleElimination";
import RoundRobin from "../components/RoundRobin";
import DoubleElimination from "../components/DoubleElimination";
import ShareStreamModal from "../components/modals/ShareStream";
import FollowUnfollow from "../components/FollowUnfollow";
import ReportModal from "../components/modals/Report";
import VideoPlayer from "../components/VideoPlayer";
import { Container } from "../layout/Container";
import Dropdown from "../components/Dropdown";
import { handleBigNumbers } from "../utils";
import Button from "../components/Button";
import NavTab from "../components/NavTab";
import Avatar from "../components/Avatar";
import Modal from "../components/Modal";
import Chat from "../components/Chat";
import Tag from "../components/Tag";
import { checkPaypal } from '../utils'
import { ENV_CONFIG } from "../config/environment-unified";
// Import Icons
import { ReactComponent as MoneyIcon } from "../img/icons/money.svg";
import { ReactComponent as MoreIcon } from "../img/icons/more.svg";
import { ReactComponent as ShareIcon } from "../img/icons/share.svg";
import { ReactComponent as VerifiedIcon } from "../img/icons/verified.svg";
import { ReactComponent as FacebookIcon } from "../img/icons/social-media/facebook-square.svg";
import { ReactComponent as TwitterIcon } from "../img/icons/social-media/twitter-square.svg";
import { ReactComponent as InstagramIcon } from "../img/icons/social-media/instagram-square.svg";
import { ReactComponent as YoutubeIcon } from "../img/icons/social-media/youtube-square.svg";
import { ReactComponent as WebsiteIcon } from "../img/icons/social-media/website-square.svg";
import ReportIcon from "../img/icons/report.svg";
import { API_ENDPOINTS } from "../config/api";

const Stream = ({ logout, user }) => {
  const { t } = useTranslation();
  let [collapseChat] = useState(false);
  const [streamData, setStreamData] = useState({});
  const history = useHistory();
  const { username } = useParams();
  const [linkedEvent, setLinkedEvent] = useState(null);
  const [linkedEventGameName, setLinkedEventGameName] = useState(null);
  const [hasAccess, setHasAccess] = useState(true); // Default to true, will check if paid event
  const [checkingAccess, setCheckingAccess] = useState(false);
  const openLoginModal = () => {
    window.dispatchEvent(new CustomEvent("corearena:auth:open", { detail: { tabIndex: 1 } }));
  };
  const [eventPovs, setEventPovs] = useState([]);
  // const [messages, setMessages] = useState([]);
  // const socketRef = useRef();
  // const writeChatRef = useRef();
  // const readChatRef = useRef();

  // // Watch Chat
  // useEffect(() => {
  //   socketRef.current = io(
  //     process.env.REACT_APP_CHAT_ENDPOINT,
  //     { transports: ["websocket"] },
  //     () => {
  //       console.log("connected");
  //     }
  //   );
  //   writeChatRef.current = io(
  //     process.env.REACT_APP_CHAT_ENDPOINT + "/writechat"
  //   );
  //   readChatRef.current = io(process.env.REACT_APP_CHAT_ENDPOINT + "/readchat");
  //   writeChatRef.current.emit("join", { streamID: username });
  //   readChatRef.current.emit("join", { streamID: username });
  //   readChatRef.current.on("send", (newMessage) => {
  //     setMessages((curr) => [...curr, newMessage]);
  //   });
  // }, [username]);

  // Get Stream Data
  useEffect(() => {
    console.log("🔍 Fetching stream data for username:", username);
    console.log("🔍 Using endpoint:", ENV_CONFIG.STREAM_ENDPOINT + username);

    // ✅ Ajout d'un indicateur de chargement
    setStreamData(prev => ({ ...prev, isLoading: true }));

    axios
      .get(ENV_CONFIG.STREAM_ENDPOINT + username, {
        withCredentials: true,
        timeout: 10000 // ✅ Timeout de 10 secondes
      })
      .then((res) => {
        console.log("✅ Stream data received:", res.data);
        console.log("✅ playbackLink:", res.data.playbackLink);
        console.log("✅ channelArn:", res.data.channelArn);
        console.log("✅ isLive:", res.data.isLive);

        // ✅ Validation des données reçues
        if (!res.data) {
          throw new Error(t("stream.aucune_donnee_recue", "Aucune donnée reçue du serveur"));
        }

        // ✅ Si isLive n'est pas défini, essayer de le récupérer depuis l'API mychannel/init
        if (res.data.isLive === undefined && res.data.channelArn) {
          console.log("🔍 isLive non défini, tentative de récupération depuis mychannel/init...");

          // Appel à l'API mychannel/init pour récupérer isLive
          axios.get(ENV_CONFIG.INIT_CHANNEL_ENDPOINT, {
            withCredentials: true,
            timeout: 5000
          })
            .then((initRes) => {
              console.log("✅ isLive récupéré depuis mychannel/init:", initRes.data.isLive);
              setStreamData({
                ...res.data,
                isLive: initRes.data.isLive,
                isLoading: false,
                error: null
              });
            })
            .catch((initErr) => {
              console.warn("⚠️ Impossible de récupérer isLive, utilisation des données par défaut");
              setStreamData({
                ...res.data,
                isLive: true, // ✅ Par défaut, considérer comme live si nous avons une playbackLink
                isLoading: false,
                error: null
              });
            });
        } else {
          setStreamData({
            ...res.data,
            isLoading: false,
            error: null
          });
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching stream data:", err);
        console.error("❌ Error response:", err.response?.data);
        console.error("❌ Error status:", err.response?.status);

        let errorMessage = "Erreur lors du chargement du stream";

        if (err.response?.status === 401) {
          console.log("🔐 Unauthorized, logging out...");
          logout();
          errorMessage = t("stream.session_expiree_veuillez", "Session expirée, veuillez vous reconnecter");
        } else if (err.response?.status === 404) {
          console.log("🔍 Stream not found, redirecting to profile...");
          history.push("/profile/" + err.response.data.username);
          return; // Ne pas afficher d'erreur si redirection
        } else if (err.code === 'ECONNABORTED') {
          errorMessage = t("stream.timeout", "Délai d'attente dépassé, vérifiez votre connexion");
        } else if (err.response?.status >= 500) {
          errorMessage = t("stream.erreur_serveur_veuillez", "Erreur serveur, veuillez réessayer plus tard");
        } else if (!err.response) {
          errorMessage = t("stream.impossible_de_se", "Impossible de se connecter au serveur");
        }

        setStreamData(prev => ({
          ...prev,
          isLoading: false,
          error: errorMessage
        }));
      });
  }, [username, logout, history, t]);

  // Check access for paid events linked to this stream
  useEffect(() => {
    const checkEventAccess = async () => {
      if (!streamData?.currentEventId) {
        setLinkedEvent(null);
        setLinkedEventGameName(null);
        setHasAccess(true);
        return;
      }

      try {
        setCheckingAccess(true);

        // Fetch event details
        const eventRes = await axios.get(
          `${ENV_CONFIG.EVENTS_ENDPOINT}/events/by-id/${streamData.currentEventId}`,
          { withCredentials: true }
        );
        const event = eventRes.data?.event;

        if (!event) {
          setHasAccess(true);
          return;
        }

        setLinkedEvent(event);

        const priceNum = (() => {
          const raw = event?.ticketPrice;
          const n = typeof raw === 'string' ? parseFloat(raw) : Number(raw);
          return Number.isFinite(n) ? n : 0;
        })();

        // If free event, grant access
        if (priceNum <= 0) {
          setHasAccess(true);
          return;
        }

        // If not logged in, deny access to paid event
        if (!user?.id) {
          setHasAccess(false);
          return;
        }

        // Check if user is the organizer
        if (event.createdBy?.toString() === user.id?.toString()) {
          setHasAccess(true);
          return;
        }

        // Tournament players/streamers are tracked via eventStreamer, not participants tickets.
        // If the user is an active assignee for this tournament event, grant access.
        if (event?.category?.slug === 'tournament' && event?.slug) {
          try {
            const playersRes = await axios.get(`${ENV_CONFIG.EVENTS_ENDPOINT}/events/${event.slug}/players`, {
              withCredentials: true
            });
            const list = playersRes.data?.players || [];
            const isAssignee = list.some((p) => String(p?.user?.id) === String(user.id));
            if (isAssignee) {
              setHasAccess(true);
              return;
            }
          } catch (_) {
            // ignore and continue with ticket checks
          }
        }

        // Paid access: user must have a ticketId on their participant row
        const participantsRes = await axios.get(
          `${ENV_CONFIG.EVENT_PARTICIPANTS_ENDPOINT}/${event.id}`,
          { withCredentials: true }
        );
        const participants = participantsRes.data?.participants || [];
        const me = participants.find((p) => String(p.userId) === String(user.id));
        setHasAccess(!!me?.ticketId);
      } catch (error) {
        console.error('Error checking event access:', error);
        // For paid content, fail closed if we cannot verify access
        setHasAccess(false);
      } finally {
        setCheckingAccess(false);
      }
    };

    checkEventAccess();
  }, [streamData?.currentEventId, user?.id]);

  // If the stream payload doesn't include a game (common in some flows),
  // show the event game by resolving linkedEvent.gameId -> game name.
  useEffect(() => {
    let mounted = true;
    const gameId = linkedEvent?.gameId;

    // Prefer stream's own game (either `game.name` or legacy `stream_games.name`).
    if (streamData?.game?.name || streamData?.stream_games?.name) {
      setLinkedEventGameName(null);
      return () => {
        mounted = false;
      };
    }

    if (!gameId) {
      setLinkedEventGameName(null);
      return () => {
        mounted = false;
      };
    }

    axios
      .get(API_ENDPOINTS.GAMES)
      .then((res) => {
        if (!mounted) return;
        const games = Array.isArray(res.data) ? res.data : [];
        const raw = String(gameId);
        const found =
          games.find((g) => String(g.id) === raw) ||
          games.find((g) => g.shortName && String(g.shortName) === raw);
        setLinkedEventGameName(found?.name || null);
      })
      .catch(() => {
        if (!mounted) return;
        setLinkedEventGameName(null);
      });

    return () => {
      mounted = false;
    };
  }, [linkedEvent?.gameId, streamData?.game?.name, streamData?.stream_games?.name]);

  const displayGameName =
    streamData?.game?.name ||
    streamData?.stream_games?.name ||
    linkedEventGameName ||
    null;

  // Multi-POV: when this stream is linked to an event, load other live POVs for the same event.
  useEffect(() => {
    if (!streamData?.currentEventId) {
      setEventPovs([]);
      return;
    }

    let mounted = true;
    axios
      .get(`/api/stream/streams/by-event/${streamData.currentEventId}`, { withCredentials: true })
      .then((res) => {
        if (!mounted) return;
        setEventPovs(res.data?.streams || []);
      })
      .catch(() => {
        if (!mounted) return;
        setEventPovs([]);
      });

    return () => {
      mounted = false;
    };
  }, [streamData?.currentEventId]);

  // Viewers presence (join/heartbeat/leave) for NGINX/RTMP
  useEffect(() => {
    if (!streamData?.channelArn || !streamData?.playbackLink) return;

    const channelArn = streamData.channelArn; // already encoded by backend
    const baseUrl = ENV_CONFIG.API_BASE_URL || '';
    let heartbeatId;

    const join = async () => {
      try {
        await axios.post(`${baseUrl}/api/stream/viewers/join`, { channelArn }, { withCredentials: true });
        window.dispatchEvent(new CustomEvent("corearena:viewers:refresh"));
      } catch (e) {
        // silent
      }
    };
    const heartbeat = async () => {
      try {
        await axios.post(`${baseUrl}/api/stream/viewers/heartbeat`, { channelArn }, { withCredentials: true });
      } catch (e) {
        // silent
      }
    };
    const leave = async () => {
      try {
        await axios.post(`${baseUrl}/api/stream/viewers/leave`, { channelArn }, { withCredentials: true });
        window.dispatchEvent(new CustomEvent("corearena:viewers:refresh"));
      } catch (e) {
        // silent
      }
    };

    join();
    heartbeatId = setInterval(heartbeat, 25000);

    const onUnload = () => { leave(); };
    window.addEventListener('beforeunload', onUnload);

    return () => {
      clearInterval(heartbeatId);
      window.removeEventListener('beforeunload', onUnload);
      leave();
    };
  }, [streamData?.channelArn, streamData?.playbackLink]);

  // const streamData = useSelector(state => state.stream.data)
  // useEffect(() => {
  //   setStreamId(streamData._id)
  // }, [streamData._id]);

  return (
    <>
      <Helmet>
        <meta
          property="og:url"
          content={"https://www.ayourlab.com/stream/" + username}
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={username + "'s stream"} />
        <meta property="og:description" content={streamData.title} />
        <meta property="og:image" content={streamData.thumbnail} />
      </Helmet>
      <MobileView>
        <MobileVersion
          streamData={streamData}
          displayGameName={displayGameName}
        />
      </MobileView>
      <BrowserView>
        <Grid collapseChat={collapseChat}>
          <div>
            <Cont>
              {streamData.isLoading ? (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "400px",
                  background: "#1a1a1a",
                  color: "white",
                  fontSize: "16px",
                  flexDirection: "column",
                  gap: "10px"
                }}>
                  <div>🔄 Chargement du stream...</div>
                  <div style={{ fontSize: "12px", opacity: 0.7 }}>Veuillez patienter</div>
                </div>
              ) : streamData.error ? (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "400px",
                  background: "#1a1a1a",
                  color: "white",
                  fontSize: "16px",
                  flexDirection: "column",
                  gap: "10px",
                  textAlign: "center",
                  padding: "20px"
                }}>
                  <div style={{ opacity: 0.85 }}>Aucun stream en direct</div>
                </div>
              ) : checkingAccess ? (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "400px",
                  background: "#1a1a1a",
                  color: "white",
                  fontSize: "16px",
                  flexDirection: "column",
                  gap: "10px"
                }}>
                  <div>🔐 Checking access...</div>
                </div>
              ) : !hasAccess && linkedEvent ? (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "400px",
                  background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
                  color: "white",
                  fontSize: "16px",
                  flexDirection: "column",
                  gap: "16px",
                  textAlign: "center",
                  padding: "40px"
                }}>
                  <div style={{ fontSize: "48px" }}>🔒</div>
                  <div style={{ fontSize: "20px", fontWeight: 600 }}>Premium Content</div>
                  <div style={{ opacity: 0.8, maxWidth: "400px" }}>
                    This stream is part of the paid event: <strong>{linkedEvent.name}</strong>
                  </div>
                  <div style={{ opacity: 0.7, fontSize: "14px" }}>
                    Get access by purchasing a ticket or redeeming a code.
                  </div>
                  <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                    <Button
                      onClick={() => history.push(`/events/${linkedEvent.slug}`)}
                      style={{ background: "#667eea", padding: "12px 24px", borderRadius: "8px" }}
                    >
                      🎟️ Get Access – {linkedEvent.ticketPrice} G-Coins
                    </Button>
                  </div>
                  {!user?.id && (
                    <div style={{ opacity: 0.6, fontSize: "13px", marginTop: "8px" }}>
                      <button
                        type="button"
                        onClick={openLoginModal}
                        style={{
                          background: "transparent",
                          border: "none",
                          padding: 0,
                          margin: 0,
                          color: "#667eea",
                          cursor: "pointer",
                          textDecoration: "underline",
                          font: "inherit"
                        }}
                      >
                        Login
                      </button>{" "}
                      to access this content
                    </div>
                  )}
                </div>
              ) : (streamData.isLive === true && streamData.playbackLink) ? (
                <>
                  {/* Multi-POV switcher (only when stream is linked to an event and user has access) */}
                  {hasAccess && streamData.currentEventId && eventPovs.length > 1 && (
                    <div style={{ padding: "10px 0 12px 0" }}>
                      <div style={{ fontSize: 13, opacity: 0.85, marginBottom: 8 }}>
                        Other live POVs (same event):
                      </div>
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        {eventPovs.map((p) => (
                          <button
                            key={p.username}
                            type="button"
                            onClick={() => {
                              if (p.username && p.username !== username) history.push(`/stream/${p.username}`);
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              padding: "6px 10px",
                              borderRadius: 999,
                              border: p.username === username ? "1px solid #667eea" : "1px solid #2D3748",
                              background: p.username === username ? "rgba(102,126,234,0.12)" : "#0b1220",
                              color: "#E5E7EB",
                              cursor: p.username === username ? "default" : "pointer",
                            }}
                          >
                            <img
                              src={p.avatar || "https://via.placeholder.com/20"}
                              alt={p.username}
                              style={{ width: 20, height: 20, borderRadius: 999, objectFit: "cover" }}
                            />
                            <span style={{ fontWeight: 600, fontSize: 13 }}>{p.username}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  {console.log("🎥 URL HLS utilisée :", streamData.playbackLink)}
                  {console.log("🎥 Stream data complet :", streamData)}
                  {console.log("🎥 isLive status :", streamData.isLive)}
                  {console.log("🎥 channelArn :", streamData.channelArn)}
                  {/* ✅ Afficher le stream si nous avons une playbackLink, même si isLive est undefined */}
                  <VideoPlayer
                    key={streamData.playbackLink}
                    streamData={streamData}
                    src={streamData.playbackLink}
                    type="hls"
                    isLive={true}
                    isMute={false}
                    autoPlay={true}
                    id="player-stream"
                  />
                </>
              ) : streamData._id ? (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "400px",
                  background: "#1a1a1a",
                  color: "white",
                  fontSize: "16px",
                  flexDirection: "column",
                  gap: "10px"
                }}>
                  <>
                    <div>⚫ Aucun stream en direct</div>
                    <div style={{ fontSize: "12px", opacity: 0.7 }}>Ce streamer n'est pas en direct</div>
                  </>
                </div>
              ) : (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "400px",
                  background: "#1a1a1a",
                  color: "white",
                  fontSize: "16px"
                }}>
                  Chargement du stream...
                </div>
              )}
            </Cont>
            <Container>
              <div style={{ paddingTop: "15px" }}>
                <Buttons streamData={streamData} />
                <Description streamData={streamData} displayGameName={displayGameName} />
                <Brackets id={streamData.user} />
              </div>
            </Container>
          </div>
          <Chat streamId={streamData._id} />
        </Grid>
      </BrowserView>
    </>
  );
};

// Sub Component
const MobileVersion = ({ streamData, displayGameName, ...rest }) => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(1);
  const list = [t('stream.chat'), t('stream.details')];
  console.log(streamData);
  return (
    <MobileGrid>
      <Cont style={{ height: "auto" }}>
        {(streamData.isLive === true && streamData.playbackLink) ? (
          <VideoPlayer
            type="hls"
            src={streamData.playbackLink}
            isLive={true}
            streamData={streamData}
            isMute={false}
            autoPlay={true}
            id="player-video-mobile"
          />
        ) : streamData._id ? (
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "300px",
            background: "#1a1a1a",
            color: "white",
            fontSize: "14px"
          }}>
            {t('stream.no_stream_live')}
          </div>
        ) : (
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "300px",
            background: "#1a1a1a",
            color: "white",
            fontSize: "14px"
          }}>
            Chargement du stream...
          </div>
        )}
      </Cont>
      <div>
        <h4>{streamData.title}</h4>
        <span
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "15px 13px",
          }}
        >
          <ViewsCounter streamData={streamData} />
        </span>
        <div>
          <div>
            <Avatar
              to={streamData.username}
              src={streamData.avatar}
              alt={streamData.username}
              size="70px"
              isLive
            />
            <div>
              <Link>
                {streamData.username} {streamData.verified && <VerifiedIcon />}
              </Link>
              {displayGameName ? <span>{displayGameName}</span> : null}
            </div>
          </div>
          <FollowUnfollow
            channelId={streamData._id}
            followed={streamData.isFollowed}
          />
        </div>
        <div>
          <NavTab
            style={{ marginTop: "20px" }}
            full
            list={list}
            index={index}
            setIndex={setIndex}
          />
          {index === 1 && <Chat {...rest} />}
          {index === 2 && <DetailsTab streamData={streamData} />}
        </div>
      </div>
    </MobileGrid>
  );
};

const MobileGrid = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  h4 {
    margin: 15px 10px 0;
  }
  > div {
    :nth-child(1) {
      height: 300px;
    }
    :nth-child(2) {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;
      ${({ theme }) => theme.hideScroller()}
      > div:nth-of-type(1) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px 0;
        > div {
          display: flex;
          align-items: center;
          flex: 1;
          > div:nth-child(2) {
            > a {
              display: block;
              font-size: 18px;
              font-family: "Poppins SemiBold";
              font-weight: 500;
              margin-bottom: 5px;
              margin-top: 5px;
              text-transform: capitalize;
              color: ${({ theme }) => theme.color.darkerText};
              transition: color 200ms;
              :hover {
                transition: color 200ms;
                color: ${({ theme }) => theme.color.primary};
              }
            }
          }
          > div:nth-child(1) {
            margin-right: 13px;
          }
        }
      }
      > div:nth-of-type(2) {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
  }
  aside {
    width: 100%;
    max-width: 100%;
    height: 100%;
    > div {
      min-height: auto;
      > div:nth-child(1) {
        max-height: calc(100vh - 377px);
        padding-bottom: 40px;
      }
      > form {
        width: auto !important;
        position: fixed;
        bottom: 0;
        left: 5px;
        right: 5px;
        width: 100%;
        top: auto;
        border-radius: 5px 5px 0 0;
        padding: 10px 7px 7px;
        background-color: ${({ theme }) => theme.color.background};
      }
    }
  }
`;

const DetailsTab = ({ streamData }) => {
  return (
    <div style={{ padding: "15px" }}>
      <div style={{ display: "flex", marginBottom: "24px" }}>
        <div>
          <div style={{ marginTop: "15px" }}>
            {streamData?.tags?.map((tag, index) => {
              return (
                <Tag to={"/tag/" + tag} key={index}>
                  {tag}
                </Tag>
              );
            })}
          </div>
        </div>
        <SocialMedia />
      </div>
      <Brackets id={streamData.user} />
    </div>
  );
};
const Brackets = ({ id }) => {
  const [tournamentId, setTournamentId] = useState(null);
  const [structure, setStructure] = useState(null);
  const [showBracket, setShowBracket] = useState(false);
  const dispatch = useDispatch();
  const { editRounds } = bindActionCreators(actionCreators, dispatch);
  useEffect(() => {
    if (id && id !== undefined)
      axios
        .get(ENV_CONFIG.TOURNAMENT_GET_STREAM_ENDPOINT + id, {
          withCredentials: true,
        })
        .then((res) => {
          setShowBracket(true);
          console.log(res.data);
          setTournamentId(res.data._id);
        })
        .catch((err) => {
          console.log(err);
        });
  }, [id]);

  useEffect(() => {
    if (tournamentId && tournamentId !== undefined) {
      console.log("here I am 2");
      axios
        .get(ENV_CONFIG.TOURNAMENT_ENDPOINT + tournamentId)
        .then((res) => {
          setStructure(res.data.structure);
          editRounds(res.data.bracket, res.data.structure, res.data.adminId);
        })
        .catch((x) => {
          console.log(x);
          editRounds(null, null);
        });
    }
  }, [editRounds, tournamentId]);

  if (showBracket && structure === "d_elim") {
    return (
      <>
        <DoubleElimination stream={true} />
      </>
    );
  } else if (showBracket && structure === "s_elim") {
    return <SingleElimination stream={true} />;
  } else if (showBracket && structure === "robin") {
    return <RoundRobin stream={true} />;
  } else return <></>;
};

const SocialMedia = ({ streamData }) => {
  return (
    <SocialMediaStyle>
      {streamData?.facebook && (
        <Button
          icon
          nofocus="true"
          target="_blank"
          href={"https://www.facebook.com/" + streamData?.facebook}
        >
          <FacebookIcon />
        </Button>
      )}
      {streamData?.twitter && (
        <Button
          icon
          nofocus="true"
          target="_blank"
          href={"https://www.twitter.com/" + streamData?.twitter}
        >
          <TwitterIcon />
        </Button>
      )}
      {streamData?.instagram && (
        <Button
          icon
          nofocus="true"
          target="_blank"
          href={"https://www.instagram.com/" + streamData?.instagram}
        >
          <InstagramIcon />
        </Button>
      )}
      {streamData?.youtube && (
        <Button
          icon
          nofocus="true"
          target="_blank"
          href={"https://www.youtube.com/c/" + streamData?.youtube}
        >
          <YoutubeIcon />
        </Button>
      )}
      {streamData?.website && (
        <Button icon nofocus="true" target="_blank" href={streamData?.website}>
          <WebsiteIcon />
        </Button>
      )}
    </SocialMediaStyle>
  );
};
const SocialMediaStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  a {
    padding: 5px;
  }
`;

const ViewsCounter = ({ streamData, logout }) => {
  const [views, setViews] = useState(0);
  const [time, setTime] = useState(0);
  const [, setError] = useState(null);

  // Fetch viewer data function
  const fetchViewerData = useCallback(async () => {
    if (!streamData.channelArn) {
      console.warn("⚠️ No channelArn provided");
      return;
    }

    try {
      // ✅ Gérer l'encodage du channelArn correctement
      let encodedChannelArn = streamData.channelArn;

      // Si le channelArn n'est pas déjà encodé, l'encoder
      if (!streamData.channelArn.includes('%')) {
        encodedChannelArn = encodeURIComponent(streamData.channelArn);
      }

      console.log("🔧 Fetching viewer data for:", encodedChannelArn);

      // ✅ Use the correct path parameter format
      const correctUrl = ENV_CONFIG.STREAM_VIEWERS_ENDPOINT + encodedChannelArn;

      console.log("🔧 URL utilisée :", correctUrl);

      const response = await axios.get(correctUrl, {
        withCredentials: true,
        timeout: 10000, // 10 second timeout
      });

      console.log("✅ Viewer data response:", response.data);

      setViews(response.data.viewerCount || 0);
      setTime(response.data.startTime || 0);
      setError(null); // Clear any previous errors

    } catch (err) {
      console.error("❌ Erreur livedata:", err.response?.status, err.response?.data);

      if (err.response) {
        if (err.response.status === 404) {
          console.warn("⚠️ Stream not found (404) - may have ended");
          setError("Stream may have ended");
          // Don't redirect immediately, let user decide
        } else if (err.response.status === 500) {
          console.error("❌ Server error (500)");
          setError("Server error");
        } else {
          console.error("❌ Other error:", err.response.status);
          setError(`Error: ${err.response.status}`);
        }
      } else {
        console.error("❌ Network error:", err.message);
        setError("Network error");
      }
    }
  }, [streamData.channelArn]);

  // Initial fetch and setup polling
  useEffect(() => {
    console.log("🔄 Setting up viewer counter for:", streamData.channelArn);

    if (!streamData.channelArn) {
      return;
    }

    // Initial fetch
    fetchViewerData();

    // Setup polling every 30 seconds
    const interval = setInterval(() => {
      console.log("🔄 Polling viewer data...");
      fetchViewerData();
    }, 30000);

    // Cleanup interval on unmount
    return () => {
      console.log("🧹 Cleaning up viewer counter interval");
      clearInterval(interval);
    };
  }, [streamData.channelArn, fetchViewerData]);

  return (
    <ViewsStyle>
      <Duration time={time} />
      <span>{handleBigNumbers(views) + " viewers"}</span>
    </ViewsStyle>
  );
};
const ViewsStyle = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > * {
    font-size: 12px;
    color: ${({ theme }) => theme.color.primaryText};
    letter-spacing: 1px;
    font-family: "Poppins Light";
  }
  @media (max-width: 576px) {
    > * {
      font-size: 14px;
    }
  }
`;
const Duration = ({ time }) => {
  const [wait, setWait] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setWait((prev) => !prev);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [wait]);

  return <Moment date={time} format="hh:mm:ss" durationFromNow />;
};

const Buttons = ({ streamData }) => {
  const { t } = useTranslation();
  const [shareModal, setShareModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [drop, setdrop] = useState(false);
  // const {username} = useParams();
  // const userLogged = useSelector((state) => state.user.data.username);
  const stremOptions = [
    {
      type: 2,
      title: t('common.report'),
      icon: ReportIcon,
      func: () => setReportModal(true),
    },
  ];
  return (
    <ButtonsStyle>
      <ViewsCounter streamData={streamData} />
      {/* {userLogged === username && <Button onClick={() => window.open("http://localhost:3000/streamChat/" + username, "Chat", "height=1000,width=300")}>
        {"Open chat box"}
      </Button>} */}
      <Button icon onClick={() => setShareModal(true)}>
        <ShareIcon />
      </Button>
      {streamData.paypalme && (
        <Button
          href={checkPaypal(streamData.paypalme)}
          target="_blank"
          variant="danger"
          size="small"
        >
          <MoneyIcon />
          {t('common.donate')}
        </Button>
      )}
      <FollowUnfollow
        channelId={streamData._id}
        followed={streamData.isFollowed}
      />
      <div
        onClick={() => {
          setdrop(!drop);
        }}
        style={{ position: "relative" }}
      >
        <Button icon>
          <MoreIcon />
        </Button>
        {drop && (
          <Dropdown
            show={drop}
            setShow={() => {
              setdrop(!drop);
            }}
            style={{ right: "-100%", top: "100%" }}
            options={stremOptions}
            margin="10px"
          />
        )}
      </div>
      <Modal
        isOpen={shareModal}
        onRequestClose={() => setShareModal(false)}
        hideModal={() => setShareModal(false)}
      >
        <ShareStreamModal
          shareURL={"https://www.ayourlab.com/stream/" + streamData.username}
        />
      </Modal>
      <Modal
        isOpen={reportModal}
        onRequestClose={() => setReportModal(false)}
        hideModal={() => setReportModal(false)}
      >
        <ReportModal id={streamData._id} />
      </Modal>
    </ButtonsStyle>
  );
};
const ButtonsStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: right;
  margin-bottom: 24px;
  ${({ theme }) => theme.gap("10px")}
  a,
  a:hover {
    svg path {
      fill: none;
      stroke: white;
    }
  }
  > button:nth-of-type(1) {
    svg {
      > * {
        /* fill: none; */
        stroke: ${({ theme }) => theme.color.primaryText};
      }
    }
  }
`;

const Description = ({ streamData, displayGameName, ...rest }) => {
  return (
    <DescriptionStyle {...rest}>
      <Avatar
        to={streamData.username}
        src={streamData.avatar}
        alt={streamData.username}
        size="70px"
        isLive
      />
      <div>
        <h4>{streamData.title}</h4>
        <Link to={"/profile/" + streamData.username}>
          {streamData.username}
          {streamData.verified && <VerifiedIcon />}
        </Link>
        <p className="small">Playing: {displayGameName || "—"}</p>
        <div>
          {streamData.tags?.map((tag, index) => {
            return (
              <Tag
                to={"/tag/" + tag}
                key={index}
                style={{ marginRight: "4px" }}
              >
                {tag}
              </Tag>
            );
          })}
        </div>
      </div>
      <SocialMedia streamData={streamData.social} />
    </DescriptionStyle>
  );
};
const DescriptionStyle = styled.article`
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding-bottom: 50px;
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
  margin-bottom: 50px;

  > div:nth-child(1) {
    margin-right: 20px;
  }

  > div:nth-child(2) {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    h4 {
      word-break: break-all;
      ${({ theme }) => theme.linesLimits(3, 1.2)}
    }
    > a {
      font-size: 14px;
      font-family: "Poppins Medium";
      font-weight: 500;
      margin-bottom: 5px;
      margin-top: 5px;
      text-transform: capitalize;
      color: ${({ theme }) => theme.color.darkerText};
      transition: color 200ms;
      :hover {
        transition: color 200ms;
        color: ${({ theme }) => theme.color.primary};
      }
      svg {
        position: relative;
        left: 6px;
        top: 1px;
      }
    }
    & > p {
      max-width: 500px;
      margin-bottom: 10px;
    }
  }
`;

const Grid = styled.div`
  height: clamp(100%, 100%, 100%);
  display: grid;
  grid-template-columns: 1.8fr ${({ collapseChat }) =>
    collapseChat ? 0 : 300}px;
  grid-template-rows: 1fr;
  overflow: hidden;
  grid-template-areas:
    "Container ChatBox"
    "Container ChatBox";
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  & > * {
    :nth-child(1) {
      grid-area: Container;
      overflow: auto;
      ${({ theme }) => theme.hideScroller}
    }
    :nth-child(2) {
      grid-area: ChatBox;
      ${({ theme }) => theme.hideScroller}
      position: fixed;
      width: 308px;
      top: 50px;
      bottom: 0;
      right: ${({ collapseChat }) => (!collapseChat ? 0 : -300)}px;
      @media (max-width: 576px) {
        display: none;
      }
    }
  }
`;

const Cont = styled.div`
  position: relative;
  width: 100%;
  background: #000;
  
  /* Use aspect-ratio to maintain 16:9 until video loads */
  aspect-ratio: 16 / 9;
  
  /* Video player will determine its own height based on aspect ratio */
  .test-cont {
    width: 100%;
    height: 100%;
    display: block;
    
    .card {
      width: 100%;
      height: 100%;
      position: relative;
      background: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      
      video {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        display: block;
      }
    }
  }

  @media only screen and (max-width: 576px) {
    aspect-ratio: 16 / 9;
  }
`;

// Map state to props
const mapStateToProps = (state) => ({
  user: state.user.data,
});

// Map dispatch to props
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Stream);
